import {NavigationEnd, Router} from "@angular/router";
/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  Component,
  Inject,
  ElementRef,
  OnInit,
  Renderer2,
  HostListener,
  OnDestroy,
} from '@angular/core';
import {ROUTES} from './sidebar-items';
import {RouteInfo} from './sidebar.metadata';
import {DOCUMENT} from "@angular/common";
import {UserData} from "../../auth.service";
import {UserRole} from "../../components/rename/add-user-role/add-user-role.component";
import {AngularFirestore} from "@angular/fire/compat/firestore";
import {EmployeeService} from "../../services/employee.service";
import {Observable, takeUntil} from "rxjs";
import {UserPermission} from "../../models/UserPermission";
import {Subject} from "rxjs/internal/Subject";
import {switchMap} from "rxjs/operators";


interface MenuPermissions {
  [permission: string]: boolean;
}


@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
})
export class SidebarComponent implements OnInit, OnDestroy {
  defaultPermissions = [
    'Dashboard',
    'Child List',
    'Child Prescreening',
    'Child Highlights',
    'Case Study',
    'Child Call And Follow-Up',
    'Unit',
    'Counselling',
    'Education',
    'Meal Mate',
    'Unit Sponsorship',
    'General Donation',
    'Education Report',
    'Donation Report',
    'Weekly Report',
    'Hospital',
    'Types',
    'Donor',
    'Event',
    'Audit Logs',
    'Inventory',
    'Vehicles',
    // Add other function names as needed
    'Audit Logs',
    'Dashboard',
    'Child Admission',
    'Donation Report',
    'Child Report',
    'Unit Sponsorship',
    'Centres',
    'Employees',
    'Tasks',
    'Ops Reports',
    'AI Powered Impact Report',
    'Counseling Report',
    'Rental Agreements'
  ];
  admissions: UserRole[] = [];
  subMenuGranted: string[] = []
  headerGroupsFound: string[] = []
  dashboardPermission = this.admissions.filter((x) => x.functionName == 'Dashboard')
  counsellingPermission = this.admissions.filter((x) => x.functionName == 'Counselling')
  educationPermission = this.admissions.filter((x) => x.functionName == 'Education')
  childAdmissionPermission = this.admissions.filter((x) => x.functionName == 'Child Admission')
  donationReport = this.admissions.filter((x) => x.functionName == 'Donation Report')
  childReport = this.admissions.filter((x) => x.functionName == 'Child Report')
  weeklyReport = this.admissions.filter((x) => x.functionName == 'Weekly Report')
  mealMate = this.admissions.filter((x) => x.functionName == 'Meal Mate')
  unitSponsorship = this.admissions.filter((x) => x.functionName == 'Unit Sponsorship')
  centres = this.admissions.filter((x) => x.functionName == 'Centres')
  Employees = this.admissions.filter((x) => x.functionName == 'Employees')
  Hospital = this.admissions.filter((x) => x.functionName == 'Hospital')
  Unit = this.admissions.filter((x) => x.functionName == 'Unit')
  Types = this.admissions.filter((x) => x.functionName == 'Types')
  Donor = this.admissions.filter((x) => x.functionName == 'Donor')
  Events = this.admissions.filter((x) => x.functionName == 'Event')
  AuditLogs = this.admissions.filter((x) => x.functionName == 'Audit Logs')
  public sidebarItems!: RouteInfo[];
  public innerHeight?: number;
  public bodyTag!: HTMLElement;
  listMaxHeight?: string;
  listMaxWidth?: string;
  headerHeight = 60;
  routerObj;
  userData: UserData
  userDetails = JSON.parse(localStorage.getItem('userData')! || '{}')
  userName = ''
  role = ''
  jobTitle = ''
  show = false;
  permissionsMap: { [key: string]: UserRole[] } = {};
  department: string
  mPermissions: UserRole[] = [];
  missingMenus: string[] = []
  _destroyed = new Subject<void>();

  constructor(
    private readonly mFirestore: AngularFirestore,
    @Inject(DOCUMENT) private document: Document,
    private renderer: Renderer2,
    public elementRef: ElementRef,
    private employeeService: EmployeeService,
    // private authService: AuthService,
    private router: Router
  ) {
    this.userData = JSON.parse(localStorage.getItem('userData')!) as UserData
    console.log(this.userData)
    this.department = this.userData.department

    this.userName = this.userData.userName
    this.role = this.userData.role
    this.jobTitle = this.userData.jobtitle
    this.routerObj = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        // close sidebar on mobile screen after menu select
        this.renderer.removeClass(this.document.body, 'overlay-open');
      }
    });
    const storedPermissions = localStorage.getItem('permissions');
    // this.admissions = storedPermissions ? JSON.parse(storedPermissions) : this.getDefaultPermissions();


    // this.mFirestore.collection('sidebarItems').doc('Menu').set({menu: ROUTES})
  }

  // loadPermissions() {
  //   this.employeeService.UserRoles$.subscribe(res => {
  //     console.log("USER ROLES ARE ", res)
  //     this.mPermissions = res
  //     this.initializePermissions()
  //
  //   })
  // }

  // sidebar.component.ts

  loadPermissions() {
    this.employeeService.permissionsUpdated$
      .pipe(
        switchMap(() => this.employeeService.UserRoles$),
        takeUntil(this._destroyed)
      )
      .subscribe(res => {
        // Firebase's first RTDB emission can arrive empty while the auth
        // token is still propagating; react to every emission (not just
        // the first) so a later, real emission still repopulates the menu.
        this.permissionsMap = {}        // reset map
        this.subMenuGranted = []        // reset granted list
        this.headerGroupsFound = []     // reset headers

        this.mPermissions = res
        this.initializePermissions()
      })
  }

  private initializePermissions(): void {
    const storedPermissions = localStorage.getItem('permissions');
    this.admissions = this.mPermissions ? this.mPermissions : this.getDefaultPermissions();
    // console.log('PERMISSIONS ARE', this.admissions)

    this.admissions.forEach((permission: UserRole) => {
      const {functionName} = permission;
      // console.log('FUNCTION NAME IS',functionName)
      if (!this.permissionsMap[functionName]) {
        this.permissionsMap[functionName] = [];
      }
      this.permissionsMap[functionName].push(permission);
      // console.log(this.permissionsMap)

    });
    console.log('PERMISSIONS-MAP : ',this.permissionsMap)
    this.checkRoles(this.sidebarItems); // Check roles and permissions

  }


  // Generate default permissions if not stored
  private getDefaultPermissions(): UserRole[] {
    return this.defaultPermissions.map((functionName: string) => {
      return {
        functionName,
        all: false,
        add: false,
        edit: false,
        archive: false,
        view: false,
        excel: false,
        showMenu: false
      };
    });
  }


  @HostListener('window:resize', ['$event'])
  windowResizecall() {
    this.setMenuHeight();
    this.checkStatuForResize(true);
  }


  @HostListener('document:mousedown', ['$event'])
  onGlobalClick(event: Event): void {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.renderer.removeClass(this.document.body, 'overlay-open');
    }
  }


  callToggleMenu(event: Event, length: number) {
    if (length > 0) {
      const parentElement = (event.target as HTMLInputElement).closest('li');
      const activeClass = parentElement?.classList.contains('active');


      if (activeClass) {
        this.renderer.removeClass(parentElement, 'active');
      } else {
        this.renderer.addClass(parentElement, 'active');
      }
    }
  }


  ngOnInit() {
    this.sidebarItems = ROUTES.filter((sidebarItem) => sidebarItem); // Filter sidebar items
    this.loadPermissions(); // Load user permissions

    this.initLeftSidebar(); // Initialize the sidebar
    this.bodyTag = this.document.body; // Assign the body element
  }


  ngOnDestroy() {
    this.routerObj.unsubscribe();
    this._destroyed.next();
    this._destroyed.complete();
  }


  initLeftSidebar() {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const _this = this;
    // Set menu height
    _this.setMenuHeight();
    _this.checkStatuForResize(true);
  }


  setMenuHeight() {
    this.innerHeight = window.innerHeight;
    const height = this.innerHeight - this.headerHeight;
    this.listMaxHeight = height + '';
    this.listMaxWidth = '500px';
  }


  isOpen() {
    return this.bodyTag.classList.contains('overlay-open');
  }


  checkStatuForResize(firstTime: boolean) {
    if (window.innerWidth < 1170) {
      this.renderer.addClass(this.document.body, 'ls-closed');
    } else {
      this.renderer.removeClass(this.document.body, 'ls-closed');
    }
  }


  mouseHover() {
    const body = this.elementRef.nativeElement.closest('body');


    if (body.classList.contains('submenu-closed')) {
      this.renderer.addClass(this.document.body, 'side-closed-hover');
      this.renderer.removeClass(this.document.body, 'submenu-closed');
    }
  }


  mouseOut() {
    const body = this.elementRef.nativeElement.closest('body');
    if (body.classList.contains('side-closed-hover')) {
      this.renderer.removeClass(this.document.body, 'side-closed-hover');
      this.renderer.addClass(this.document.body, 'submenu-closed');
    }
  }


//ORIGINAL


  //CONSISE
  private checkRoles(sidebarItems: RouteInfo[]) {
    // console.log(sidebarItems)
    try {
      for (const item of sidebarItems) {
        let showItem = false; // Default showMenu value

        // Define a reusable function to handle submenu permissions
        const handleSubmenuPermissions = (item: RouteInfo, menus: string[]) => {
          try {
            menus.forEach(menu => this.checkSubmenuPermission(item, menu, this.permissionsMap));
            item.showMenu = this.checkHeaders(menus, item);   //This is original logic line
            // item.showMenu = true   //this is temporary
          } catch (error) {
            console.error(`Error in handleSubmenuPermissions:  Header: ${item.title}  ${menus} `, error);
          }
        };

        switch (item.title) {
          case 'Dashboard': {
   try {
     showItem = this.permissionsMap['Dashboard']?.[0]?.showMenu || false;
     item.showMenu = showItem;

   }catch (e) {
     console.log('DASHBOARD'+ item.title, e);
   }
            break;
          }
          case 'DMS': {
            showItem = this.permissionsMap['DMS']?.[0]?.showMenu || false;
            item.showMenu = showItem;
            break;
          }
          case 'Dashboards': {
            if (item.submenu) {
              const menus = ['Donation Dashboard','Education Dashboard','Counselling Dashboard','Transport Dashboard','Operation Dashboard'];
              handleSubmenuPermissions(item, menus);
            }
            break;
          }
          case 'Child Master': {
            if (item.submenu) {
              const menus = ['Child Admission', 'Child List', 'Units', 'Case Study', 'Child Call And Follow-Up', 'Prescreening List', 'Child Highlights',];
              handleSubmenuPermissions(item, menus);
            }
            break;
          }
          case 'Education': {
            showItem = this.permissionsMap['Education']?.[0]?.showMenu || false;
            item.showMenu = showItem;

            if (item.submenu) {
              const menus = ['Individual Session', 'Group Session', 'Education Reports', 'Follow Up Assessment', 'Follow Up Question'];
              handleSubmenuPermissions(item, menus);
            }
            break;
          }
          case 'Education Depository': {
            item.showMenu = showItem;
            if (item.submenu) {
              const menus = ['Education Observation','Daily Work Update','Education SOP', 'Education Induction', 'Special Day', 'Education MOM', 'Education Highlight', 'Education Presentation'];
              handleSubmenuPermissions(item, menus);
            }
            break;
          }
          case 'Counselling': {
            if (item.submenu) {
              const menus = ['Individual Sessions', 'Group Sessions', 'Assessments', 'Follow Up Assessments', 'Follow Up Questions'];
              handleSubmenuPermissions(item, menus);
            }
            break;
          }
          case 'Counselling Depository': {
            if (item.submenu) {
              const menus = ['Counselling Observation','Work Updates', 'Counselling Sop', 'Group Session Topics', 'Counselling MOM','Counselling Induction','Counselling Highlight','Counselling Center Log','Counselling Presentation'];
              handleSubmenuPermissions(item, menus);
            }
            break;
          }
          case 'Operations Dept': {
            if (item.submenu) {
              const menus = ['Feedback', 'Testimonials', 'Mealmate', 'Bookings', 'Centre Highlights', 'Events', 'Contacts','Unit Sponsorship'];
              handleSubmenuPermissions(item, menus);
            }
            break;
          }
          case 'Transport': {
            if (item.submenu) {
              const menus = ['Drivers', 'Trip Log','Vehicles','Fuel Filling Log', 'Servicing Log'];
              handleSubmenuPermissions(item, menus);
            }
            break;
          }
          case 'Donation Reports': {
            if (item.submenu) {
              const menus = ['Donation Report', 'Attempted Donations', 'Failed Donations', 'Razorpay Payments', 'Custom Payments'];
              handleSubmenuPermissions(item, menus);
            }
            break;
          }
          case 'Ops Reports': {
            if (item.submenu) {
              const menus = [
                'Admission Report', 'Admission Yearly Report','Child Report','Daily Child Report', 'Weekly Report',
                'Occupancy Report', 'Efficiency Report', 'Quarterly Report', 'Unit & Floor Report', 'Age Group Report',
                'Hospital Count Report', 'Hospital Wise Occ.', 'Child Wise Hospital', 'State Count Report', 'Duration Report',
                'Allergy Report', 'Gender Count Report', 'Yearly Count Report', 'Blood Group Report','Admission Log History','Average Stay Report', 'Om Shanti Report'
              ];
              handleSubmenuPermissions(item, menus);
            }
            break;
          }
          case 'Inventory': {
            if (item.submenu) {
              const menus = [
                'Products', 'Instock Entry', 'Centre Inventory','Inventory Category','Stock Adjustment', 'Stock Transfer', 'Direct Issue',
                'Request Products', 'Issue Requests', 'Issued Products', 'Purchase List', 'Hygiene Kit','Inventory Log','Daily Inventory Count Report','Inventory Tracking Report'
              ];
              handleSubmenuPermissions(item, menus);
            }
            break;
          }
          case 'Education Reports': {
            showItem = this.permissionsMap['Education Report']?.[0]?.showMenu || false;
            item.showMenu = showItem;

            if (item.submenu) {
              const menus = ['Education Impact Report', 'Report Card', 'Analytical Report', 'Edu. Session Count', 'Follow Up Report', 'MIS Report'];
              handleSubmenuPermissions(item, menus);
            }
            break;
          }
          case 'Counselling Reports': {
            try {
              const counsellingPermissions = this.permissionsMap['Counselling Reports'];
              if (Array.isArray(counsellingPermissions) && counsellingPermissions.length > 0) {
                showItem = counsellingPermissions[0].showMenu || false;
              } else {
                showItem = false;
              }

              item.showMenu = showItem;

              if (item.submenu) {
                const menus = [
                  'Counseling Impact Report',
                  'Challenges Report',
                  'Intervention Report',
                  'Comparison',
                  'Cou. Session Count',
                  "Progress Report",
                  'Followup Overview'
                ];
                handleSubmenuPermissions(item, menus);
              }
            } catch (e) {
              console.error('Counselling Reports', e);
            }
            break;
          }

          case 'Reminders': {
            if (item.submenu) {
              const menus = ['Payments', 'Followups', 'Birthdays'];
              handleSubmenuPermissions(item, menus);

            }
            break;
          }
          case 'Masters': {
            if (item.submenu) {
              const menus = ['Centres', 'Users', 'Types', 'Prefix Master', 'Media', 'Glossary', 'Audit Logs'];
              handleSubmenuPermissions(item, menus);
            }
            break;
          }
          case 'Donor Management': {
            if (item.submenu) {
              const menus = ['Donor Profile', 'Visitor Profile'];
              handleSubmenuPermissions(item, menus);
            }
            break;
          }
          case 'AI Powered Impact Report': {
            // No role-based rules yet — visible to everyone until it's wired into role management.
            // if email is genmgr@accesslife.org or test1@gmail.com

            try {
              showItem = this.permissionsMap['AI Powered Impact Report']?.[0]?.showMenu || false;
              item.showMenu = showItem;

            }catch (e) {
              console.log('AI Powered Impact Report'+ item.title, e);
            }
            break;
          }
          case 'Narrative Impact Report':{
            try {
              showItem = this.permissionsMap['Narrative Impact Report']?.[0]?.showMenu || false;
              item.showMenu = showItem;

            }catch (e) {
              console.log('Narrative Impact Report'+ item.title, e);
            }
         break;
          }


          case 'Depository': {
            if (item.submenu) {
              const menus = ['8080 Enquiry', 'Award Recognition', 'Membership', 'Hospitals', 'Media Coverages','Minutes of Meeting', 'Volunteer', 'Resource Repository', 'Staff Learning Sessions', 'Email'];
              handleSubmenuPermissions(item, menus);
            }
            break;
          }
          case 'Ticketing': {
            if (item.submenu) {
              const menus = ['Ticket List'];
              handleSubmenuPermissions(item, menus);
            }
            break;
          }
          case 'Tasks': {
            if (item.submenu) {
              const menus = ['Tasks'];
              handleSubmenuPermissions(item, menus);
            }
            break;
          }
          case 'Rental Agreements': {
            try {
              const allowedEmails = ['genmgr@accesslife.org', 'test1@gmail.com'];
              showItem = this.role === 'SuperAdmin'
                || allowedEmails.includes(this.userData?.email)
                || (this.permissionsMap['Rental Agreements']?.[0]?.showMenu || false);
              item.showMenu = showItem;
            } catch (e) {
              console.log('Rental Agreements' + item.title, e);
            }
            break;
          }
        }
      }
      // console.log(this.missingMenus)

//       for (const item of sidebarItems) {
//         let showItem = false; // Default showMenu value
//         switch (item.title) {
//           case 'Dashboard': {
//             showItem = this.permissionsMap['Dashboard'][0]?.showMenu || false;
//             console.log('DASHBOARD', showItem)
//             item.showMenu = showItem
//           }
//             break;
//           case 'Child Master': {
//             // alert('Child Master Found')
//             // showItem = this.showMenu('Child Admission', 0)
//             // item.showMenu = showItem
//             // Set submenu visibility within Admissions
//
//
//             if (item.submenu) {
//               this.checkSubmenuPermission(item, 'Child Admission', this.permissionsMap)
//               this.checkSubmenuPermission(item, 'Child List', this.permissionsMap)
//               this.checkSubmenuPermission(item, 'Units', this.permissionsMap)
//               this.checkSubmenuPermission(item, 'Case Study', this.permissionsMap)
//               this.checkSubmenuPermission(item, 'Child Call And Follow-Up', this.permissionsMap)
// const menus = ['Child Admission', 'Child List', 'Units', 'Case Study', 'Child Call And Follow-Up']
//               item.showMenu = this.checkHeaders(menus,item)
//               // alert(this.checkHeaders(menus,item))
//
//             }
//
//
//             break;
//           }
//           case 'Education': {
//             showItem = this.permissionsMap['Education'][0]?.showMenu || false;
//             // Set submenu visibility within Education
//             item.showMenu = showItem
//
//             if (item.submenu) {
//               this.checkSubmenuPermission(item, 'Individual Session', this.permissionsMap)
//               this.checkSubmenuPermission(item, 'Group Session', this.permissionsMap)
//               this.checkSubmenuPermission(item, 'Education Reports', this.permissionsMap)
//               this.checkSubmenuPermission(item, 'Follow Up Assessment', this.permissionsMap)
//               this.checkSubmenuPermission(item, 'Follow Up Question', this.permissionsMap)
//               /* const educationIndividualMenu = item.submenu.find(x => x.title === 'Individual');
//               const educationGroupSessionsMenu = item.submenu.find(x => x.title === 'Group Sessions');
//               const educationReportMenu = item.submenu.find(x => x.title === 'Reports');
//               educationIndividualMenu!!.showMenu = showItem
//               educationGroupSessionsMenu!!.showMenu = showItem
//               educationReportMenu!!.showMenu = showItem
//               // educationIndividualMenu?.(educationIndividualMenu => (educationIndividualMenu.showMenu = showItem));
//               // educationGroupSessionsMenu?.(educationGroupSessionsMenu => (educationGroupSessionsMenu.showMenu = showItem));
//               // educationReportMenu?.(educationReportMenu => (educationReportMenu.showMenu = this.permissionsMap['Education Report'][0]?.showMenu || false)); // Reports permission assumed for Education Reports*/
//             }
//             const menus = ['Individual Session', 'Group Session', 'Education Reports', 'Follow Up Assessment', 'Follow Up Question']
//             item.showMenu = this.checkHeaders(menus,item)
//             // item.showMenu = showItem
//
//             break;
//           }
//           case 'Counselling': {
//             if (item.submenu) {
//               const menus = [
//                 'Individual Sessions',
//                 'Group Sessions',
//                 'Assessments',
//                 'Follow Up Assessments',
//                 'Follow Up Questions'
//               ];
//
//               // Dynamically check permissions for each menu
//               menus.forEach(menu => this.checkSubmenuPermission(item, menu, this.permissionsMap));
//
//               // Check if any of the menus are granted
//               item.showMenu = this.checkHeaders(menus, item);
//             }
//             break;
//           }
//
//           case 'Operations Dept': {
//             this.checkSubmenuPermission(item, 'Feedback', this.permissionsMap)
//             this.checkSubmenuPermission(item, 'Testimonials', this.permissionsMap)
//             this.checkSubmenuPermission(item, 'Mealmate', this.permissionsMap)
//             this.checkSubmenuPermission(item, 'Bookings', this.permissionsMap)
//             this.checkSubmenuPermission(item, 'Centre Highlights', this.permissionsMap)
//             this.checkSubmenuPermission(item, 'Events', this.permissionsMap)
//             this.checkSubmenuPermission(item, 'Contacts ', this.permissionsMap)
//
//             break;
//           }
//           case 'Transport': {
//             this.checkSubmenuPermission(item, 'Drivers', this.permissionsMap)
//             this.checkSubmenuPermission(item, 'Trip Log', this.permissionsMap)
//             this.checkSubmenuPermission(item, 'Fuel Filling Log', this.permissionsMap)
//             this.checkSubmenuPermission(item, 'Servicing Log', this.permissionsMap)
//
//             // showItem = this.permissionsMap['Vehicles'][0]?.showMenu || false
//             // item.showMenu = showItem
//             break;
//           }
//           case 'Donation Reports': {
//             this.checkSubmenuPermission(item, 'Donation Report', this.permissionsMap)
//             this.checkSubmenuPermission(item, 'Attempted Donations', this.permissionsMap)
//             this.checkSubmenuPermission(item, 'Failed Donations', this.permissionsMap)
//             this.checkSubmenuPermission(item, 'Razorpay Payments', this.permissionsMap)
//             this.checkSubmenuPermission(item, 'Custom Payments', this.permissionsMap)
//             /*    showItem = this.permissionsMap['Donation Report'][0]?.showMenu || false
//                 // item.showMenu = showItem
//                 // alert(`Item.showmenu ${item.showMenu}`)
//                 const donationReportMenu = item.submenu.find(x => x.title === 'Donation Report');
//                 const attemptedDonations = item.submenu.find(x => x.title === 'Attempted Donations');
//                 const failedDonations = item.submenu.find(x => x.title === 'Failed Donations');
//                 failedDonations!!.showMenu = showItem
//                 donationReportMenu!!.showMenu = showItem
//                 attemptedDonations!!.showMenu = showItem
//                 const razorPayReports = item.submenu.find(x => x.title === 'Razorpay Payments')
//                 razorPayReports!!.showMenu = showItem
//                 // console.log('Inside Donation Reports', showItem)
//                 item.showMenu = showItem*/
//             break;
//           }
//
//           case 'Ops Reports': {
//             this.checkSubmenuPermission(item, 'Attempted Donations', this.permissionsMap)
//             this.checkSubmenuPermission(item, 'Admission Report', this.permissionsMap)
//             this.checkSubmenuPermission(item, 'Admission Count Report', this.permissionsMap)
//             this.checkSubmenuPermission(item, 'Daily Child Report', this.permissionsMap)
//             this.checkSubmenuPermission(item, 'Weekly Report', this.permissionsMap)
//             this.checkSubmenuPermission(item, 'Occupancy Report', this.permissionsMap)
//             this.checkSubmenuPermission(item, 'Efficiency Report', this.permissionsMap)
//             this.checkSubmenuPermission(item, 'Quarterly Report', this.permissionsMap)
//             this.checkSubmenuPermission(item, 'Unit & Floor Report', this.permissionsMap)
//             this.checkSubmenuPermission(item, 'Unit & Floor Report', this.permissionsMap)
//             this.checkSubmenuPermission(item, 'Age Group Report', this.permissionsMap)
//             this.checkSubmenuPermission(item, 'Hospital Count Report', this.permissionsMap)
//             this.checkSubmenuPermission(item, 'Hospital Wise Occ.', this.permissionsMap)
//             this.checkSubmenuPermission(item, 'Child Wise Hospital', this.permissionsMap)
//             this.checkSubmenuPermission(item, 'State Count Report', this.permissionsMap)
//             this.checkSubmenuPermission(item, 'Duration Report', this.permissionsMap)
//             this.checkSubmenuPermission(item, 'Allergy Report', this.permissionsMap)
//             this.checkSubmenuPermission(item, 'Gender Count Report', this.permissionsMap)
//             this.checkSubmenuPermission(item, 'Yearly Count Report', this.permissionsMap)
//             this.checkSubmenuPermission(item, 'Blood Group Report', this.permissionsMap)
//
//             showItem = this.permissionsMap['Child Report'][0]?.showMenu || false
//
//
//             break;
//           }
//
//           case 'Inventory': {
//             try {
//               this.checkSubmenuPermission(item, 'Products', this.permissionsMap)
//               this.checkSubmenuPermission(item, 'Instock Entry', this.permissionsMap)
//               this.checkSubmenuPermission(item, 'Centre Inventory', this.permissionsMap)
//               this.checkSubmenuPermission(item, 'Stock Adjustment', this.permissionsMap)
//               this.checkSubmenuPermission(item, 'Stock Transfer', this.permissionsMap)
//               this.checkSubmenuPermission(item, 'Direct Issue', this.permissionsMap)
//               this.checkSubmenuPermission(item, 'Request Products', this.permissionsMap)
//               this.checkSubmenuPermission(item, 'Issue Requests', this.permissionsMap)
//               this.checkSubmenuPermission(item, 'Issued Products', this.permissionsMap)
//               this.checkSubmenuPermission(item, 'Purchase List', this.permissionsMap)
//               this.checkSubmenuPermission(item, 'Hygiene Kit', this.permissionsMap)
//
//
//               //
//               // showItem = this.permissionsMap['Inventory'][0]?.showMenu || false;
//               // item.showMenu = showItem
//               // const productsMenu = item.submenu.find(x => x.title == 'Products')
//               // productsMenu!!.showMenu != showItem
//               // const instockEntry = item.submenu.find(x => x.title === 'Instock Entry')
//               // instockEntry!!.showMenu = showItem
//               //
//               // const centreInventory = item.submenu.find(x => x.title === 'Centre Inventory')
//               // centreInventory!!.showMenu = showItem
//               //
//               // const stockInventory = item.submenu.find(x => x.title === 'Stock Adjustment')
//               // stockInventory!!.showMenu = showItem
//               // const stockTransfer = item.submenu.find(x => x.title === 'Stock Transfer')
//               // stockTransfer!!.showMenu = showItem
//               // const directIssue = item.submenu.find(x => x.title === 'Direct Issue')
//               // directIssue!!.showMenu = showItem
//               // const requestProducts = item.submenu.find(x => x.title === 'Request Products')
//               // requestProducts!!.showMenu = showItem
//               // // const issueProducts = item.submenu.find(x => x.title === 'Issue Products')
//               // // issueProducts!!.showMenu = showItem
//               //
//               // const issuedProducts = item.submenu.find(x => x.title === 'Issued Products')
//               // issuedProducts!!.showMenu = showItem
//               // const purchaseList = item.submenu.find(x => x.title === 'Purchase List')
//               // purchaseList!!.showMenu = showItem
//
//             } catch (e) {
//               console.log('error  in inventory roles', e)
//             }
//
//             break;
//           }
//           case 'Education Reports': // Replace with logic based on your permission structure
//             showItem = this.permissionsMap['Education Report'][0]?.showMenu || false
//             item.showMenu = showItem
//
//
//             // Set submenu visibility within Reports (add logic based on your permissions)
//             if (item.submenu) {
//               // ... (add logic for submenu visibility based on reports permissions)
//               this.checkSubmenuPermission(item, 'Education Impact Report', this.permissionsMap)
//               this.checkSubmenuPermission(item, 'Report Card', this.permissionsMap)
//               this.checkSubmenuPermission(item, 'Analytical Report', this.permissionsMap)
//               this.checkSubmenuPermission(item, 'Session Count', this.permissionsMap)
//               this.checkSubmenuPermission(item, 'Follow Up Report', this.permissionsMap)
//               this.checkSubmenuPermission(item, 'MIS Report', this.permissionsMap)
//
//             }
//             break;
//           case 'Counseling Reports': // Replace with logic based on your permission structure
//             showItem = this.permissionsMap['Counseling Report'][0]?.showMenu || false
//             item.showMenu = showItem
//             // Set submenu visibility within Reports (add logic based on your permissions)
//             if (item.submenu) {
//               // ... (add logic for submenu visibility based on reports permissions)
//               this.checkSubmenuPermission(item, 'Counseling Impact Report', this.permissionsMap)
//               this.checkSubmenuPermission(item, 'Challenges Report', this.permissionsMap)
//               this.checkSubmenuPermission(item, 'Intervention Report', this.permissionsMap)
//               this.checkSubmenuPermission(item, 'Comparison', this.permissionsMap)
//               this.checkSubmenuPermission(item, 'Session Count', this.permissionsMap)
//               this.checkSubmenuPermission(item, 'Followup Overview', this.permissionsMap)
//
//
//
//             }
//             break;
//
//           case 'Donation': // Replace with logic based on your permission structure
//             try {
//               showItem = (this.permissionsMap['General Donation'][0]?.showMenu || this.permissionsMap['Unit Sponsorship'][0]?.showMenu || this.permissionsMap['Meal Mate'][0]?.showMenu) || false;
//               // Set submenu visibility within Donation (add logic based on your permissions)
//               item.showMenu = showItem
//               if (item.submenu) {
//                 this.checkSubmenuPermission(item, 'Mealmate', this.permissionsMap)
//                 this.checkSubmenuPermission(item, 'Bookings', this.permissionsMap)
//                 this.checkSubmenuPermission(item, 'Unit Sponsorship', this.permissionsMap)
//
//                 // ... (add logic for submenu visibility based on donation permissions)
//                /* const mealMateMenu = item.submenu.find(x => x.title === 'Mealmate');
//                 const bookingsMenu = item.submenu.find(x => x.title === 'Bookings');
//                 bookingsMenu!!.showMenu = this.permissionsMap['Meal Mate'][0]?.showMenu
//                 const unitSponsorshipMenu = item.submenu.find(x => x.title === 'Unit Sponsorship');
//                 unitSponsorshipMenu!!.showMenu = this.permissionsMap['Unit Sponsorship'][0]?.showMenu
//                 mealMateMenu!!.showMenu = this.permissionsMap['Meal Mate'][0]?.showMenu*/
//               }
//
//             } catch (e) {
//               console.log('error in donation ', e)
//             }
//             break;
//           case 'Reminders': {
//
//             // showItem = ((this.permissionsMap['Child Admission'][0]?.showMenu
//             //   || this.permissionsMap['Meal Mate'][0]?.showMenu
//             //   || this.permissionsMap['Child Admission'][0]?.showMenu
//             // ) || false) && this.department != 'External User'
//             if (item.submenu) {
//               this.checkSubmenuPermission(item, 'Payments', this.permissionsMap)
//               this.checkSubmenuPermission(item, 'Followups', this.permissionsMap)
//               this.checkSubmenuPermission(item, 'Birthdays', this.permissionsMap)
//
//               // ... (add logic for submenu visibility based on donation permissions)
//            /*   const paymentsMenu = item.submenu.find(x => x.title === 'Payments');
//               const followUpMenu = item.submenu.find(x => x.title === 'Followups');
//               paymentsMenu!!.showMenu = this.permissionsMap['General Donation'][0]?.showMenu
//               followUpMenu!!.showMenu = this.permissionsMap['Child Admission'][0]?.showMenu && this.department != 'External User'*/
//
//             }
//             break;
//           }
//           case 'Masters': {
//
//             // showItem = ((this.permissionsMap['Child Admission'][0]?.showMenu
//             //   || this.permissionsMap['Meal Mate'][0]?.showMenu
//             //   || this.permissionsMap['Child Admission'][0]?.showMenu
//             // ) || false) && this.department != 'External User'
//             if (item.submenu) {
//               this.checkSubmenuPermission(item, 'Centres', this.permissionsMap)
//               this.checkSubmenuPermission(item, 'Users', this.permissionsMap)
//               this.checkSubmenuPermission(item, 'Types', this.permissionsMap)
//               this.checkSubmenuPermission(item, 'Prefix Master', this.permissionsMap)
//               this.checkSubmenuPermission(item, 'Types', this.permissionsMap)
//               this.checkSubmenuPermission(item, 'Media', this.permissionsMap)
//               this.checkSubmenuPermission(item, 'Glossary', this.permissionsMap)
//               this.checkSubmenuPermission(item, 'Audit Logs', this.permissionsMap)
//
//               // ... (add logic for submenu visibility based on donation permissions)
//               /*   const paymentsMenu = item.submenu.find(x => x.title === 'Payments');
//                  const followUpMenu = item.submenu.find(x => x.title === 'Followups');
//                  paymentsMenu!!.showMenu = this.permissionsMap['General Donation'][0]?.showMenu
//                  followUpMenu!!.showMenu = this.permissionsMap['Child Admission'][0]?.showMenu && this.department != 'External User'*/
//
//             }
//             break;
//           }
//
//         }
//         // item.showMenu = showItem
//       }

      // * Masters Menu

    } catch (e) {
      console.error(e);
    }
    //FOR MASTERS MENU

  }

  checkSubmenuPermission(item: RouteInfo, menuName: string, permissionMap: {
    [p: string]: UserRole[]
  }) {
    try {
      const submenuItem = item.submenu.find(x => x.title === menuName);
      if (submenuItem) {
        submenuItem.showMenu = permissionMap[menuName.trim()]?.[0]?.showMenu || false;
        if (submenuItem.showMenu) {
          this.subMenuGranted.push(menuName);
          this.headerGroupsFound.push(menuName);
          // console.log(this.subMenuGranted);
        }
      } else {
        // console.log(`NF MENU in ${item.title} `, menuName);
      }
    } catch (error) {
      console.log(`NF MENU in ${item.title} `, menuName);
      this.missingMenus.push(`${menuName}  in ${item.title}`)
      console.error('Error in checkSubmenuPermission:', error);
    }
  }

  showMenu(menuName: string, index: number) {
    return this.permissionsMap[menuName]?.[index]?.showMenu || false
  }

  private setSubMenuPermissions(submenu: RouteInfo[] | undefined, permissionFlag: boolean) {
    if (submenu) {
      submenu.forEach(subItem => {
        subItem.showMenu = permissionFlag;
      });
    }
  }
  // Check if any menu in the provided list exists in headerGroupsFound
  private checkHeaders(menus: string[], item: RouteInfo): boolean {
    // Check if any menu in the provided list exists in headerGroupsFound
    const hasCommonItems = menus.some(menu => this.headerGroupsFound.includes(menu));

    // If common items are found, return true; otherwise, return false
    return hasCommonItems;
  }
}

